import { ApolloClient, from } from '@apollo/client';

import { cache } from './cache';
import { authLink } from './links/authLink';
import { errorLink } from './links/errorLink';
import { httpLink } from './links/httpLink';
import { retryLink } from './links/retryLink';

/**
 * The single Apollo Client instance for the app. Exported as a module-level singleton (not
 * created per-render) so `AuthContext.logout` can call `apolloClient.clearStore()` (§5.5) without
 * a circular dependency on `ApolloProvider`. `errorLink` sits first so it wraps every downstream
 * link and can `forward()` a retried operation through `authLink` again after a silent refresh.
 */
export const apolloClient = new ApolloClient({
  link: from([errorLink, authLink, retryLink, httpLink]),
  cache,
  defaultOptions: {
    watchQuery: {
      fetchPolicy: 'cache-first',
    },
  },
});
